/**
 * @file This is the route configuration file for all the protected routes
 * in the application.
 */
import TimesheetConfirmation from '../../Shared/Components/ConfirmationDialog';
import {
    default as ClinicianTimeReview,
    default as TimesheetReview,
} from '../../Shared/Components/TimesheetReview';
import Expenses from '../../Shared/Pages/Expenses';
import ProcessedTimesheetDetails from '../Pages/ProcessedTimesheetDetails';
import ProcessedTimesheetDetailsTablePage from '../Pages/ProcessedTimesheetDetailsTablePage';
import SubmittedDialog from '../../Shared/Components/Expense/SubmittedDialog';
import PreCoded from '../../Shared/Pages/PreCoded';
import InvoicingInitiationPage from '../Pages/InvoicingInitiationPage';
import InvoiceManagementPage from '../Pages/InvoiceManagementPage';
import Timesheets from '../../Shared/Pages/Timesheets';
import Timesheet from '../../pages/TimeAndPay/Timesheet';
import TimesheetSave from '../../pages/TimeAndPay/TimesheetSave';
import TimesheetSubmit from '../../pages/TimeAndPay/TimesheetSubmit';
import CreditCards from '../Pages/CreditCards';
import ExpenseReview from '../../Shared/Pages/ExpenseReview';
import ClinicianReimbursement from '../../Shared/Pages/ClinicianReimbursement';
import PendingCCReview from '../../Shared/Pages/PendingCCReview';
import CreditCardReview from '../../Shared/Pages/CreditCardReview';
import CreditCardDetails from '../../Shared/Pages/CreditCardDetails';
import ExpenseRedirector from '../../Shared/Components/Expense/ExpenseRedirector';
import ProcessedTimesheetsPages from '../Pages/ProcessedTimesheetsPages';
import VendorPayment from '../../Shared/Pages/VendorPayment';
import VendorPaymentReview from '../../Shared/Pages/VendorPaymentReview';
import VaultPayment from '../../Shared/Pages/VaultPayment';
import VaultChargesReview from '../../Shared/Pages/VaultChargesReview';

const adminRoutes = [
    {
        path: '/login/callback',
    },

    {
        path: '/timesheets',
        component: Timesheets,
    },
    {
        path: '/timesheet/:id?/view',
        component: Timesheet,
        mode: 'view',
    },
    {
        path: '/timesheet/:id?/edit',
        component: Timesheet,
        mode: 'edit',
    },
    {
        path: '/timesheet/create',
        component: Timesheet,
        mode: 'create',
    },
    {
        path: '/timesheet/save',
        component: TimesheetSave,
    },
    {
        path: '/timesheet/:id?/submit',
        component: TimesheetSubmit,
    },
    {
        path: '/clinician/:clinicianId?/timesheet/:id?/review/:locationId?',
        component: TimesheetReview,
    },
    {
        path: '/clinician/:clinicianId?/timesheet/:id?/review',
        component: ClinicianTimeReview,
    },
    {
        path: '/invoicing/initiation',
        component: InvoicingInitiationPage,
    },
    {
        path: '/invoicing/invoice-management',
        component: InvoiceManagementPage,
    },
    {
        path: '/processed-timesheets/bill-pay',
        component: (props) => (
            <ProcessedTimesheetsPages
                pageType="processedTimesheetsBP"
                title="Needs Review Timesheets - Bill Pay Team"
                {...props}
            />
        ),
    },
    {
        path: '/processed-timesheets/team-coordinator',
        component: (props) => (
            <ProcessedTimesheetsPages
                pageType="processedTimesheetsTC"
                title="Needs Review Timesheets - Team Coordinators View"
                {...props}
            />
        ),
    },
    {
        path: '/processed-timesheets',
        component: (props) => (
            <ProcessedTimesheetsPages
                pageType="processedTimesheets"
                title="All Processed Timesheets"
                {...props}
            />
        ),
    },
    {
        path: '/processed-timesheets/:id',
        component: ProcessedTimesheetDetails,
    },
    {
        path: '/processed-timesheets/:id/details',
        component: ProcessedTimesheetDetailsTablePage,
    },
    {
        path: '/expenses',
        component: Expenses,
    },
    {
        path: '/expenses/review',
        component: ExpenseReview,
    },
    {
        path: '/expenses/pending-cc/review',
        component: PendingCCReview,
    },
    {
        path: '/expenses/credit-card/review',
        component: CreditCardReview,
    },
    {
        path: '/expenses/vault/review',
        component: VaultChargesReview,
    },
    {
        path: '/expenses/vault/:id?',
        component: VaultPayment,
    },
    {
        path: '/expenses/submit',
        component: SubmittedDialog,
    },
    {
        path: '/expenses/clinician-reimbursement/:id?',
        component: ClinicianReimbursement,
    },
    {
        path: '/expenses/payment-request/review',
        component: VendorPaymentReview,
    },
    {
        path: '/expenses/payment-request/:id?',
        component: VendorPayment,
    },
    {
        path: '/expenses/vault/:id?',
        component: null,
    },
    {
        path: '/expenses/cc/:id?',
        component: (props) => <PreCoded mode="cc" {...props} />,
    },
    {
        path: '/expenses/pending-cc/:id?',
        component: (props) => <PreCoded mode="pending-cc" {...props} />,
    },
    {
        path: '/expenses/credit-card/:id?',
        component: (props) => <CreditCardDetails {...props} />,
    },
    {
        path: '/timesheet/confirmation/:mode?',
        component: TimesheetConfirmation,
    },
    {
        path: '/credit-cards',
        component: CreditCards,
    },
    {
        path: '/expense-redirect/:expenseId?',
        component: ExpenseRedirector,
    },
];

export default adminRoutes;
